import { stringifyEvents } from '../utils';
export var sendEventsRequest = function (_a) {
    var appKey = _a.appKey, events = _a.events;
    try {
        navigator.sendBeacon("https://track.saygames.io/events/".concat(appKey), stringifyEvents(events));
    }
    catch (_b) {
        fetch("https://track.saygames.io/events/".concat(appKey), {
            method: 'POST',
            body: stringifyEvents(events),
            keepalive: true,
        }).catch(console.log);
    }
};
//# sourceMappingURL=send-events.js.map